import React from 'react'
import { Typography, Alert, Button, Space, Card } from 'antd'
import { UserAddOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import { useAppSelector } from '@store'
import AdminAccountsPanel from '@components/AdminAccountsPanel/AdminAccountsPanel'

const { Title, Text, Paragraph } = Typography

const AdminAccountsPage: React.FC = () => {
  const admin = useAppSelector((s) => s.auth.admin)
  const navigate = useNavigate()
  const isSuper = admin?.role === 'SUPER_ADMIN'

  if (!admin) {
    return null
  }

  if (!isSuper) {
    const roleText =
      admin.role === 'ADMIN' ? '管理员' : admin.role === 'OPERATOR' ? '操作员' : admin.role
    return (
      <div>
        <Title level={2} style={{ marginTop: 0, marginBottom: 16 }}>
          <UserAddOutlined style={{ marginRight: 8 }} />
          子账号授权
        </Title>
        <Alert
          type="warning"
          showIcon
          message="当前账号无法授权子账号"
          description={
            <div>
              <Paragraph style={{ marginBottom: 8 }}>
                您当前以「<Text strong>{roleText}</Text>」身份登录。给其他人开通后台子账号、改角色或删除子账号，只能由{' '}
                <Text strong>超级管理员（母账号）</Text> 操作。
              </Paragraph>
              <Paragraph type="secondary" style={{ marginBottom: 0 }}>
                请使用超级管理员账号登录本后台，再进入左侧菜单 <Text code>子账号授权</Text> 添加手机号子账号；或联系本单位超级管理员在后台为您开通。
              </Paragraph>
            </div>
          }
          style={{ marginBottom: 24 }}
        />
        <Card size="small" title="超级管理员登录后如何操作">
          <ol style={{ margin: 0, paddingLeft: 20 }}>
            <li>左侧菜单点「子账号授权」（在「数据统计」和「系统设置」之间）</li>
            <li>或进入「系统设置」，页面顶部有入口说明；向下滚动也有「管理员账号」区块</li>
            <li>点「添加账号」，填写 <Text strong>手机号</Text>、初始密码与角色后保存即可</li>
          </ol>
        </Card>
        <Space style={{ marginTop: 24 }}>
          <Button type="primary" onClick={() => navigate('/settings')}>
            去系统设置看看说明
          </Button>
          <Button onClick={() => navigate('/dashboard')}>返回仪表板</Button>
        </Space>
      </div>
    )
  }

  return (
    <div>
      <Title level={2} style={{ marginTop: 0, marginBottom: 8 }}>
        子账号授权
      </Title>
      <Text type="secondary" style={{ display: 'block', marginBottom: 24 }}>
        在此添加或管理后台子账号（须绑定手机号）。同一功能也可在「系统设置」中的「管理员账号」区块使用。
      </Text>
      <AdminAccountsPanel />
    </div>
  )
}

export default AdminAccountsPage
